<template>
  <div>
    <div class="intro-y flex items-center h-10">
      <h2 class="text-lg font-medium truncate mr-3">
        Cases History
      </h2>
      <BarChart2Icon class="report-box__icon text-theme-1" />
    </div>
    <div class="intro-y box p-5 mt-3">
      <div class="flex flex-col justify-between sm:flex-row sm:items-center">
        <div class="flex mb-4">
          <div>
            <div
              class="text-theme-20 dark:text-gray-300 text-lg xl:text-xl font-bold"
            >
              {{ this_month }}
            </div>
            <div class="text-gray-600 dark:text-gray-600">This Month</div>
          </div>
          <div
            class="w-px h-12 border border-r border-dashed border-gray-300 dark:border-dark-5 mx-4 xl:mx-6"
          ></div>
          <div>
            <div
              class="text-gray-600 dark:text-gray-600 text-lg xl:text-xl font-medium"
            >
              {{ last_month }}
            </div>
            <div class="text-gray-600 dark:text-gray-600">Last Month</div>
          </div>
        </div>
        <div class="flex items-center">
          <div class="dropdown sm:ml-auto mb-4 xl:mt-0 mr-4">
            <select
              v-model="offence_key"
              class="p-2 dropdown-toggle w-40 button font-normal border dark:border-dark-5 text-white dark:text-gray-300 relative flex items-center text-gray-700"
              @change="run()"
            >
              <option value="">Filter by Offence</option>
              <option
                v-for="(offence, key) in offences_types"
                :key="key"
                :value="offence.key"
                class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"
                >{{ offence.value }}</option
              >
            </select>
          </div>
          <div class="mb-4 xl:mt-0">
            <DownloadChart
              @click="downloadCanvas('historyChart', 'titleHistoryChart')"
            />
          </div>
        </div>
      </div>
      <div ref="historyChart">
        <h3 ref="titleHistoryChart" class="hidden mt-4 text-lg">
          Corruption Cases History
        </h3>
        <BarChart
          :width="width"
          :height="height"
          :chart-data="data"
          :options="options"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
// import StackedBarChart from "@/components/StackedBarChart";

export default {
  props: {
    width: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      ReportFilter: "",
      current_year: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      prev_year: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      this_month: 0,
      last_month: 0,
      offences_types: [],
      offence_filter: {},
      offence_key: ""
    };
  },
  computed: {
    filterParams() {
      return this.$store.state.filtersMenu.selectedFilters;
    },
    this_year() {
      return new Date().getFullYear();
    },
    last_year() {
      return this.this_year - 1;
    },
    data() {
      return {
        labels: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ],
        datasets: [
          {
            label: this.this_year,
            backgroundColor: "#4472c4",
            data: this.current_year
          },
          {
            label: this.last_year,
            backgroundColor: "#133054",
            data: this.prev_year
          }
        ]
      };
    },
    options() {
      return {
        legend: {
          display: true
        },
        scales: {
          xAxes: [
            {
              stacked: true,
              ticks: {
                fontSize: "12",
                fontColor: this.$store.state.main.darkMode
                  ? "#718096"
                  : "#777777"
              },
              gridLines: {
                display: false
              }
            }
          ],
          yAxes: [
            {
              stacked: true,
              ticks: {
                fontSize: "12",
                fontColor: this.$store.state.main.darkMode
                  ? "#718096"
                  : "#777777",
                callback: function(value) {
                  return value;
                }
              },
              gridLines: {
                color: this.$store.state.main.darkMode ? "#718096" : "#D8D8D8",
                zeroLineColor: this.$store.state.main.darkMode
                  ? "#718096"
                  : "#D8D8D8",
                drawBorder: false
              }
            }
          ]
        }
      };
    }
  },
  watch: {
    "$store.state.filtersMenu.count": {
      handler: function() {
        this.run();
      }
    }
  },
  mounted() {
    this.run();
    this.getOffences();
  },
  methods: {
    run() {
      // let _year = 2018;
      let _year = new Date().getFullYear();
      let _prev_year = _year - 1;
      let param = {
        ...this.filterParams
      };
      let url = `${window.host}/api/monthly-count/${_year}`;

      if (this.offence_key) url += `?case_type[]=${this.offence_key}`;

      axios
        .get(url, {
          params: param
        })
        .then(response => {
          if (response.data) {
            this.current_year = response.data[_year];
            this.prev_year = response.data[_prev_year];
            this.this_month = response.data.thisMonth;
            this.last_month = response.data.lastMonth;
          }
        });
    },
    getOffences() {
      axios.get(`${window.host}/api/case-types-params`).then(response => {
        if (response.data) this.offences_types = response.data;
      });
    }
  }
};
</script>
